export default "__VITE_ASSET__BBVrdKph__"